import axios from "axios";
import { api } from "../config";

// ✅ Create axios instance instead of global defaults
const axiosInstance = axios.create({
  baseURL: api.API_URL,
  headers: {
    "Content-Type": "application/json",
     Accept: "application/json",
     "Content-Type": "multipart/form-data",
  },
});

// ✅ Request interceptor → always attach token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
   
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor → handle errors & token refresh
axiosInstance.interceptors.response.use(
  (response) => (response.data ? response.data : response),
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const { status } = error.response;

      if (status === 401 && !originalRequest._retry) {
          localStorage.clear();
      window.location.href = "/login";
        originalRequest._retry = true;

        try {
          const refreshToken = localStorage.getItem("refreshToken");
          if (refreshToken) {
            const res = await axios.post(`${api.API_URL}/auth/refresh`, {
              token: refreshToken,
            });

            const newToken = res.data?.accessToken;
            if (newToken) {
              localStorage.setItem("accessToken", newToken);

              axiosInstance.defaults.headers.Authorization = `Bearer ${newToken}`;
              originalRequest.headers.Authorization = `Bearer ${newToken}`;

              return axiosInstance(originalRequest); // retry failed request
            }
          }
        } catch (err) {
          // ❌ If refresh also fails → logout user
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("user");
          window.location.href = "/login"; // redirect to login
        }
      }

      // Handle other errors
      let message;
      switch (status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          message = "Invalid or expired credentials";
          break;
        case 404:
          message = "Data not found";
          break;
        default:
          message = error.response.data?.message || error.message;
      }
      return Promise.reject(message);
    }

    return Promise.reject(error);
  }
);

// ✅ Helper to set/remove Authorization header
export const setAuthorization = (token) => {
  if (token) {
    axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.Authorization;
  }
};

// ✅ API Client wrapper
class APIClient {
  get = (url, params) => axiosInstance.get(url, { params });
  create = (url, data) => axiosInstance.post(url, data);
  update = (url, data) => axiosInstance.patch(url, data);
  put = (url, data) => axiosInstance.put(url, data);
  delete = (url, config) => axiosInstance.delete(url, { ...config });
}

// ✅ Get logged in user
export const getLoggedinUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export { APIClient, axiosInstance };
